/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import * as Types from '@r-client/data/graphql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type IAccreditationPresignedDocumentUploadMutationVariables =
  Types.Exact<{
    input: Types.IAccreditationPresignedDocumentUploadInput;
  }>;

export type IAccreditationPresignedDocumentUploadMutation = {
  __typename?: 'Mutation';
  accreditationPresignedDocumentUpload?:
    | {
        __typename?: 'AccreditationPresignedDocumentUploadPayload';
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
        presignedFileUpload?:
          | {
              __typename?: 'PresignedFileUpload';
              id: string;
              fileName?: string | null | undefined;
              originalFileName?: string | null | undefined;
              publicFileUrl?: string | null | undefined;
              uploadUrl?: string | null | undefined;
              uploadUrlExpiresAt?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ICreateAccreditationVerificationMutationVariables = Types.Exact<{
  input: Types.IAccreditationVerificationCreateInput;
}>;

export type ICreateAccreditationVerificationMutation = {
  __typename?: 'Mutation';
  accreditationVerificationsCreate?:
    | {
        __typename?: 'AccreditationVerificationCreatePayload';
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
        accreditationVerification?:
          | {
              __typename?: 'AccreditationVerification';
              id: string;
              state: Types.IAccreditationVerificationStateEnum;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type IGetEmploymentDetailsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type IGetEmploymentDetailsQuery = {
  __typename?: 'Query';
  onboardingData?:
    | {
        __typename?: 'UserOnboardingData';
        id: string;
        employmentStatus?:
          | Types.IOnboardingDataEmploymentStatusEnum
          | null
          | undefined;
        jobTitle?: string | null | undefined;
        jobIndustryEnum?:
          | Types.IOnboardingDataJobIndustryEnum
          | null
          | undefined;
        jobIndustry?: string | null | undefined;
        recentJobCompanyName?: string | null | undefined;
        finraAffiliated?: boolean | null | undefined;
        finraAffiliatedDescription?: string | null | undefined;
        publicCompanyAffiliated?: boolean | null | undefined;
        publicCompanyAffiliatedDescription?: string | null | undefined;
      }
    | null
    | undefined;
};

export type IGetInvestorProfileQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type IGetInvestorProfileQuery = {
  __typename?: 'Query';
  onboardingData?:
    | {
        __typename?: 'UserOnboardingData';
        id: string;
        digitalAssetExperience?: boolean | null | undefined;
        digitalAssetExperienceYears?:
          | Types.IOnboardingDataDigitalAssetExperienceYearsEnum
          | null
          | undefined;
        netWorthCents?: number | null | undefined;
        incomeCents?: number | null | undefined;
        riskTolerance?:
          | Types.IOnboardingDataRiskToleranceEnum
          | null
          | undefined;
        investmentObjective?:
          | Types.IOnboardingDataInvestmentObjectiveEnum
          | null
          | undefined;
      }
    | null
    | undefined;
  user?:
    | {
        __typename?: 'User';
        id: string;
        investorProfile?:
          | {
              __typename?: 'InvestorProfile';
              id: string;
              accreditationVerification?:
                | {
                    __typename?: 'AccreditationVerification';
                    id: string;
                    state: Types.IAccreditationVerificationStateEnum;
                  }
                | null
                | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
  allInvestorEntities: Array<{
    __typename?: 'InvestorEntityType';
    id: string;
    entityType: Types.IInvestorEntityTypesEnum;
  }>;
};

export type IGetOnboardingFlowStateQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type IGetOnboardingFlowStateQuery = {
  __typename?: 'Query';
  user?:
    | {
        __typename?: 'User';
        id: string;
        onboardingFlowState?:
          | Types.IUserOnboardingFlowStateEnum
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type IGetOnboardingJourneyQueryVariables = Types.Exact<{
  flowType?: Types.InputMaybe<Types.IOnboardingJourneyFlowType>;
}>;

export type IGetOnboardingJourneyQuery = {
  __typename?: 'Query';
  onboardingJourney?:
    | {
        __typename?: 'UserOnboardingJourney';
        id: string;
        globalStatus?: Types.IOnboardingJourneyGlobalStatus | null | undefined;
        custodyAccountSetupStatus: Types.IUserOnboardingJourneyStatusEnum;
        kycVerificationStatus: Types.IUserOnboardingJourneyStatusEnum;
        mfaSetupStatus: Types.IUserOnboardingJourneyStatusEnum;
        walletSetupStatus?:
          | Types.IUserOnboardingJourneyStatusEnum
          | null
          | undefined;
        personalDetailsStatus: Types.IUserOnboardingJourneyStatusEnum;
        poaProvidedStatus?:
          | Types.IUserOnboardingJourneyStatusEnum
          | null
          | undefined;
        employmentDataStatus?:
          | Types.IUserOnboardingJourneyStatusEnum
          | null
          | undefined;
        investorProfileStatus?:
          | Types.IUserOnboardingJourneyStatusEnum
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type IGetPersonalDetailsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type IGetPersonalDetailsQuery = {
  __typename?: 'Query';
  user?:
    | {
        __typename?: 'User';
        id: string;
        firstName?: string | null | undefined;
        lastName?: string | null | undefined;
        userProfile?:
          | {
              __typename?: 'UserProfile';
              id: string;
              bio?: string | null | undefined;
            }
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type ISignUpGlobalUserMutationVariables = Types.Exact<{
  input: Types.IAuthSignUpGlobalUserInput;
}>;

export type ISignUpGlobalUserMutation = {
  __typename?: 'Mutation';
  signUpGlobalUser?:
    | {
        __typename?: 'AuthSignUpGlobalUserPayload';
        user?: { __typename?: 'User'; id: string } | null | undefined;
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type IUpdateEmploymentDetailsMutationVariables = Types.Exact<{
  onboardingData: Types.IOnboardingDataInput;
}>;

export type IUpdateEmploymentDetailsMutation = {
  __typename?: 'Mutation';
  onboardingDataUpdate?:
    | {
        __typename?: 'OnboardingDataUpdatePayload';
        onboardingData?:
          | {
              __typename?: 'UserOnboardingData';
              id: string;
              employmentStatus?:
                | Types.IOnboardingDataEmploymentStatusEnum
                | null
                | undefined;
              jobTitle?: string | null | undefined;
              jobIndustryEnum?:
                | Types.IOnboardingDataJobIndustryEnum
                | null
                | undefined;
              jobIndustry?: string | null | undefined;
              recentJobCompanyName?: string | null | undefined;
              finraAffiliated?: boolean | null | undefined;
              finraAffiliatedDescription?: string | null | undefined;
              publicCompanyAffiliated?: boolean | null | undefined;
              publicCompanyAffiliatedDescription?: string | null | undefined;
            }
          | null
          | undefined;
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type IUpdateInvestorProfileMutationVariables = Types.Exact<{
  onboardingData: Types.IOnboardingDataInput;
}>;

export type IUpdateInvestorProfileMutation = {
  __typename?: 'Mutation';
  onboardingDataUpdate?:
    | {
        __typename?: 'OnboardingDataUpdatePayload';
        onboardingData?:
          | {
              __typename?: 'UserOnboardingData';
              id: string;
              digitalAssetExperience?: boolean | null | undefined;
              digitalAssetExperienceYears?:
                | Types.IOnboardingDataDigitalAssetExperienceYearsEnum
                | null
                | undefined;
              netWorthCents?: number | null | undefined;
              incomeCents?: number | null | undefined;
              riskTolerance?:
                | Types.IOnboardingDataRiskToleranceEnum
                | null
                | undefined;
              investmentObjective?:
                | Types.IOnboardingDataInvestmentObjectiveEnum
                | null
                | undefined;
            }
          | null
          | undefined;
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type IUpdateOnboardingFlowStateMutationVariables = Types.Exact<{
  onboardingFlowState: Types.IUserOnboardingFlowStateEnum;
}>;

export type IUpdateOnboardingFlowStateMutation = {
  __typename?: 'Mutation';
  userOnboardingFlowStateUpdate?:
    | {
        __typename?: 'UserOnboardingFlowStateUpdatePayload';
        user?:
          | {
              __typename?: 'User';
              id: string;
              onboardingFlowState?:
                | Types.IUserOnboardingFlowStateEnum
                | null
                | undefined;
            }
          | null
          | undefined;
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type IUpdateOnboardingJourneyStepMutationVariables = Types.Exact<{
  input: Types.IUserOnboardingJourneyUpdateStepStatusInput;
}>;

export type IUpdateOnboardingJourneyStepMutation = {
  __typename?: 'Mutation';
  onboardingJourneyUpdateStep?:
    | {
        __typename?: 'UserOnboardingJourneyUpdateStepStatusPayload';
        onboardingJourney?:
          | {
              __typename?: 'UserOnboardingJourney';
              id: string;
              custodyAccountSetupStatus: Types.IUserOnboardingJourneyStatusEnum;
              kycVerificationStatus: Types.IUserOnboardingJourneyStatusEnum;
              mfaSetupStatus: Types.IUserOnboardingJourneyStatusEnum;
              walletSetupStatus?:
                | Types.IUserOnboardingJourneyStatusEnum
                | null
                | undefined;
              personalDetailsStatus: Types.IUserOnboardingJourneyStatusEnum;
              poaProvidedStatus?:
                | Types.IUserOnboardingJourneyStatusEnum
                | null
                | undefined;
              employmentDataStatus?:
                | Types.IUserOnboardingJourneyStatusEnum
                | null
                | undefined;
              investorProfileStatus?:
                | Types.IUserOnboardingJourneyStatusEnum
                | null
                | undefined;
            }
          | null
          | undefined;
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type IUpdatePersonalDetailsMutationVariables = Types.Exact<{
  user: Types.IUserInput;
  shouldUpdateName: Types.Scalars['Boolean']['input'];
  userProfile: Types.IUserProfileInput;
  privacySettings: Types.IUserPrivacySettingsInput;
}>;

export type IUpdatePersonalDetailsMutation = {
  __typename?: 'Mutation';
  userUpdate?:
    | {
        __typename?: 'UserUpdatePayload';
        user?:
          | {
              __typename?: 'User';
              id: string;
              firstName?: string | null | undefined;
              lastName?: string | null | undefined;
            }
          | null
          | undefined;
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
      }
    | null
    | undefined;
  userProfileUpdate?:
    | {
        __typename?: 'UserProfileUpdatePayload';
        userProfile?:
          | {
              __typename?: 'UserProfile';
              id: string;
              bio?: string | null | undefined;
            }
          | null
          | undefined;
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
      }
    | null
    | undefined;
  userPrivacySettingsUpdate?:
    | {
        __typename?: 'UserPrivacySettingsUpdatePayload';
        privacySettings?:
          | Array<{
              __typename?: 'UserPrivacySetting';
              category: Types.IUserPrivacySettingCategoryEnum;
              visibility: Types.IUserPrivacySettingVisibilityEnum;
            }>
          | null
          | undefined;
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
      }
    | null
    | undefined;
};

export type IUserMfaEnableMutationVariables = Types.Exact<{
  secretKey: Types.Scalars['String']['input'];
  code: Types.Scalars['String']['input'];
}>;

export type IUserMfaEnableMutation = {
  __typename?: 'Mutation';
  userMfaEnable?:
    | {
        __typename?: 'UserMfaEnablePayload';
        mfaBackupCodes?:
          | Array<{
              __typename?: 'MultiFactorAuthenticationBackupCode';
              code: string;
            }>
          | null
          | undefined;
        errors?:
          | Array<{ __typename?: 'ValidationError'; message: string }>
          | null
          | undefined;
      }
    | null
    | undefined;
};

export const AccreditationPresignedDocumentUploadDocument = gql`
  mutation AccreditationPresignedDocumentUpload(
    $input: AccreditationPresignedDocumentUploadInput!
  ) {
    accreditationPresignedDocumentUpload(input: $input) {
      errors {
        message
      }
      presignedFileUpload {
        id
        fileName
        originalFileName
        publicFileUrl
        uploadUrl
        uploadUrlExpiresAt
      }
    }
  }
`;
export type IAccreditationPresignedDocumentUploadMutationFn =
  Apollo.MutationFunction<
    IAccreditationPresignedDocumentUploadMutation,
    IAccreditationPresignedDocumentUploadMutationVariables
  >;
export type AccreditationPresignedDocumentUploadMutationResult =
  Apollo.MutationResult<IAccreditationPresignedDocumentUploadMutation>;
export type AccreditationPresignedDocumentUploadMutationOptions =
  Apollo.BaseMutationOptions<
    IAccreditationPresignedDocumentUploadMutation,
    IAccreditationPresignedDocumentUploadMutationVariables
  >;
export const CreateAccreditationVerificationDocument = gql`
  mutation CreateAccreditationVerification(
    $input: AccreditationVerificationCreateInput!
  ) {
    accreditationVerificationsCreate(input: $input) {
      errors {
        message
      }
      accreditationVerification {
        id
        state
      }
    }
  }
`;
export type ICreateAccreditationVerificationMutationFn =
  Apollo.MutationFunction<
    ICreateAccreditationVerificationMutation,
    ICreateAccreditationVerificationMutationVariables
  >;
export type CreateAccreditationVerificationMutationResult =
  Apollo.MutationResult<ICreateAccreditationVerificationMutation>;
export type CreateAccreditationVerificationMutationOptions =
  Apollo.BaseMutationOptions<
    ICreateAccreditationVerificationMutation,
    ICreateAccreditationVerificationMutationVariables
  >;
export const GetEmploymentDetailsDocument = gql`
  query GetEmploymentDetails {
    onboardingData {
      id
      employmentStatus
      jobTitle
      jobIndustryEnum
      jobIndustry
      recentJobCompanyName
      finraAffiliated
      finraAffiliatedDescription
      publicCompanyAffiliated
      publicCompanyAffiliatedDescription
    }
  }
`;
export type GetEmploymentDetailsQueryResult = Apollo.QueryResult<
  IGetEmploymentDetailsQuery,
  IGetEmploymentDetailsQueryVariables
>;
export const GetInvestorProfileDocument = gql`
  query GetInvestorProfile {
    onboardingData {
      id
      digitalAssetExperience
      digitalAssetExperienceYears
      netWorthCents
      incomeCents
      riskTolerance
      investmentObjective
    }
    user {
      id
      investorProfile {
        id
        accreditationVerification {
          id
          state
        }
      }
    }
    allInvestorEntities {
      id
      entityType
    }
  }
`;
export type GetInvestorProfileQueryResult = Apollo.QueryResult<
  IGetInvestorProfileQuery,
  IGetInvestorProfileQueryVariables
>;
export const GetOnboardingFlowStateDocument = gql`
  query GetOnboardingFlowState {
    user {
      id
      onboardingFlowState
    }
  }
`;
export type GetOnboardingFlowStateQueryResult = Apollo.QueryResult<
  IGetOnboardingFlowStateQuery,
  IGetOnboardingFlowStateQueryVariables
>;
export const GetOnboardingJourneyDocument = gql`
  query GetOnboardingJourney($flowType: OnboardingJourneyFlowType) {
    onboardingJourney(flowType: $flowType) {
      id
      globalStatus
      custodyAccountSetupStatus
      kycVerificationStatus
      mfaSetupStatus
      walletSetupStatus
      personalDetailsStatus
      poaProvidedStatus
      employmentDataStatus
      investorProfileStatus
    }
  }
`;
export type GetOnboardingJourneyQueryResult = Apollo.QueryResult<
  IGetOnboardingJourneyQuery,
  IGetOnboardingJourneyQueryVariables
>;
export const GetPersonalDetailsDocument = gql`
  query GetPersonalDetails {
    user {
      id
      firstName
      lastName
      userProfile {
        id
        bio
      }
    }
  }
`;
export type GetPersonalDetailsQueryResult = Apollo.QueryResult<
  IGetPersonalDetailsQuery,
  IGetPersonalDetailsQueryVariables
>;
export const SignUpGlobalUserDocument = gql`
  mutation SignUpGlobalUser($input: AuthSignUpGlobalUserInput!) {
    signUpGlobalUser(input: $input) {
      user {
        id
      }
      errors {
        message
      }
    }
  }
`;
export type ISignUpGlobalUserMutationFn = Apollo.MutationFunction<
  ISignUpGlobalUserMutation,
  ISignUpGlobalUserMutationVariables
>;
export type SignUpGlobalUserMutationResult =
  Apollo.MutationResult<ISignUpGlobalUserMutation>;
export type SignUpGlobalUserMutationOptions = Apollo.BaseMutationOptions<
  ISignUpGlobalUserMutation,
  ISignUpGlobalUserMutationVariables
>;
export const UpdateEmploymentDetailsDocument = gql`
  mutation UpdateEmploymentDetails($onboardingData: OnboardingDataInput!) {
    onboardingDataUpdate(input: { onboardingData: $onboardingData }) {
      onboardingData {
        id
        employmentStatus
        jobTitle
        jobIndustryEnum
        jobIndustry
        recentJobCompanyName
        finraAffiliated
        finraAffiliatedDescription
        publicCompanyAffiliated
        publicCompanyAffiliatedDescription
      }
      errors {
        message
      }
    }
  }
`;
export type IUpdateEmploymentDetailsMutationFn = Apollo.MutationFunction<
  IUpdateEmploymentDetailsMutation,
  IUpdateEmploymentDetailsMutationVariables
>;
export type UpdateEmploymentDetailsMutationResult =
  Apollo.MutationResult<IUpdateEmploymentDetailsMutation>;
export type UpdateEmploymentDetailsMutationOptions = Apollo.BaseMutationOptions<
  IUpdateEmploymentDetailsMutation,
  IUpdateEmploymentDetailsMutationVariables
>;
export const UpdateInvestorProfileDocument = gql`
  mutation UpdateInvestorProfile($onboardingData: OnboardingDataInput!) {
    onboardingDataUpdate(input: { onboardingData: $onboardingData }) {
      onboardingData {
        id
        digitalAssetExperience
        digitalAssetExperienceYears
        netWorthCents
        incomeCents
        riskTolerance
        investmentObjective
      }
      errors {
        message
      }
    }
  }
`;
export type IUpdateInvestorProfileMutationFn = Apollo.MutationFunction<
  IUpdateInvestorProfileMutation,
  IUpdateInvestorProfileMutationVariables
>;
export type UpdateInvestorProfileMutationResult =
  Apollo.MutationResult<IUpdateInvestorProfileMutation>;
export type UpdateInvestorProfileMutationOptions = Apollo.BaseMutationOptions<
  IUpdateInvestorProfileMutation,
  IUpdateInvestorProfileMutationVariables
>;
export const UpdateOnboardingFlowStateDocument = gql`
  mutation UpdateOnboardingFlowState(
    $onboardingFlowState: UserOnboardingFlowStateEnum!
  ) {
    userOnboardingFlowStateUpdate(
      input: { onboardingFlowState: $onboardingFlowState }
    ) {
      user {
        id
        onboardingFlowState
      }
      errors {
        message
      }
    }
  }
`;
export type IUpdateOnboardingFlowStateMutationFn = Apollo.MutationFunction<
  IUpdateOnboardingFlowStateMutation,
  IUpdateOnboardingFlowStateMutationVariables
>;
export type UpdateOnboardingFlowStateMutationResult =
  Apollo.MutationResult<IUpdateOnboardingFlowStateMutation>;
export type UpdateOnboardingFlowStateMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateOnboardingFlowStateMutation,
    IUpdateOnboardingFlowStateMutationVariables
  >;
export const UpdateOnboardingJourneyStepDocument = gql`
  mutation UpdateOnboardingJourneyStep(
    $input: UserOnboardingJourneyUpdateStepStatusInput!
  ) {
    onboardingJourneyUpdateStep(input: $input) {
      onboardingJourney {
        id
        custodyAccountSetupStatus
        kycVerificationStatus
        mfaSetupStatus
        walletSetupStatus
        personalDetailsStatus
        poaProvidedStatus
        employmentDataStatus
        investorProfileStatus
      }
      errors {
        message
      }
    }
  }
`;
export type IUpdateOnboardingJourneyStepMutationFn = Apollo.MutationFunction<
  IUpdateOnboardingJourneyStepMutation,
  IUpdateOnboardingJourneyStepMutationVariables
>;
export type UpdateOnboardingJourneyStepMutationResult =
  Apollo.MutationResult<IUpdateOnboardingJourneyStepMutation>;
export type UpdateOnboardingJourneyStepMutationOptions =
  Apollo.BaseMutationOptions<
    IUpdateOnboardingJourneyStepMutation,
    IUpdateOnboardingJourneyStepMutationVariables
  >;
export const UpdatePersonalDetailsDocument = gql`
  mutation UpdatePersonalDetails(
    $user: UserInput!
    $shouldUpdateName: Boolean!
    $userProfile: UserProfileInput!
    $privacySettings: UserPrivacySettingsInput!
  ) {
    userUpdate(input: { user: $user }) @include(if: $shouldUpdateName) {
      user {
        id
        firstName
        lastName
      }
      errors {
        message
      }
    }
    userProfileUpdate(input: { userProfile: $userProfile }) {
      userProfile {
        id
        bio
      }
      errors {
        message
      }
    }
    userPrivacySettingsUpdate(input: { settings: $privacySettings }) {
      privacySettings {
        category
        visibility
      }
      errors {
        message
      }
    }
  }
`;
export type IUpdatePersonalDetailsMutationFn = Apollo.MutationFunction<
  IUpdatePersonalDetailsMutation,
  IUpdatePersonalDetailsMutationVariables
>;
export type UpdatePersonalDetailsMutationResult =
  Apollo.MutationResult<IUpdatePersonalDetailsMutation>;
export type UpdatePersonalDetailsMutationOptions = Apollo.BaseMutationOptions<
  IUpdatePersonalDetailsMutation,
  IUpdatePersonalDetailsMutationVariables
>;
export const UserMfaEnableDocument = gql`
  mutation UserMfaEnable($secretKey: String!, $code: String!) {
    userMfaEnable(input: { secretKey: $secretKey, code: $code }) {
      mfaBackupCodes {
        code
      }
      errors {
        message
      }
    }
  }
`;
export type IUserMfaEnableMutationFn = Apollo.MutationFunction<
  IUserMfaEnableMutation,
  IUserMfaEnableMutationVariables
>;
export type UserMfaEnableMutationResult =
  Apollo.MutationResult<IUserMfaEnableMutation>;
export type UserMfaEnableMutationOptions = Apollo.BaseMutationOptions<
  IUserMfaEnableMutation,
  IUserMfaEnableMutationVariables
>;
